<template>
<div class="chapter">
<div class="inner_page">
<p class="capcenter"><a id="img-front"></a> <img alt="The Black Watch in Canada. P. 267" class="imgcenter" src="Images/img0001.jpg"/><br class="calibre3"/>
The Black Watch in Canada.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?cdee54ce